import React from 'react';
import type { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  AppBar,
  Box,
  Button,
  Divider,
  Toolbar,
  Hidden,
  Typography,
  Link,
  makeStyles,
  SvgIcon
} from '@material-ui/core';
import { APP_VERSION } from 'src/constants';
import Logo from 'src/components/Logo';
import SearchIcon from '@material-ui/icons/Search';
import Settings from '../DashboardLayout/TopBar/Settings';


interface TopBarProps {
  className?: string;
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
  },
  toolbar: {
    height: 64,
  },
  routerLink: {
    textDecoration: 'none',
    marginRight: '1rem'
  },
  logo: {
    marginRight: theme.spacing(2),
  },
  link: {
    backgroundColor: 'inherit',
    '&:hover': {
      color: theme.palette.text.primary
    },
    display: 'flex',
    alignItems: "center",
    justifyContent: "center",
    height: '100%',
    padding: '25px',
    fontSize: '.875rem',
    fontWeight: theme.typography.fontWeightMedium,
  },

  divider: {
    width: 1,
    height: 32,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2)
  },
  button: {
    color: theme.palette.background.default,
    backgroundColor: theme.palette.text.primary
  }
}));

const TopBar: FC<TopBarProps> = ({ className, ...rest }) => {
  const classes = useStyles();

  return (
    <AppBar
      className={clsx(classes.root, className)}
      color="default"
      {...rest}
    >
      <Toolbar className={classes.toolbar}>
        <RouterLink className={classes.routerLink} to="/">
          <Logo className={classes.logo} />
        </RouterLink>
        {/* <Hidden mdDown>
          <Typography
            variant="caption"
            color="textSecondary"
          >
            Version
            {' '}
            {APP_VERSION}
          </Typography>
        </Hidden> */}
        <Box flexGrow={1} />

        <Link
          className={classes.link}
          color="textSecondary"
          component={RouterLink}
          to="/"
          underline="none"
          variant="body2"
        >

          <SvgIcon fontSize="default">
            <SearchIcon color="inherit" />
          </SvgIcon>

          Search
        </Link>



        {/* <Link
          className={classes.link}
          color="secondary"
          component={RouterLink}
          to="/api"
          underline="none"
          variant="body2"
        >
          Developer API
        </Link>
        <Link
          className={classes.link}
          color="textSecondary"
          component={RouterLink}
          to="/app"
          underline="none"
          variant="body2"
        >
          Dashboard
        </Link>
        <Link
          className={classes.link}
          color="textSecondary"
          component={RouterLink}
          to="/login"
          underline="none"
          variant="body2"
        >
          Login
        </Link>
        <Divider className={classes.divider} />
        <Button
          className={classes.button}
          color="secondary"
          component="a"
          href="/register"
          variant="contained"
          size="small"
        >
          Join the Network
        </Button>
        <Divider className={classes.divider} /> */}
        <Settings />
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string
};

export default TopBar;
